import { render } from "./FavoriteRoutes.vue?vue&type=template&id=ae9e9e94"
import script from "./FavoriteRoutes.vue?vue&type=script&lang=js"
export * from "./FavoriteRoutes.vue?vue&type=script&lang=js"

import "./FavoriteRoutes.vue?vue&type=style&index=0&id=ae9e9e94&scope=true&lang=css"
script.render = render

export default script